/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lastseenyesterday2Inputs */



/**
* | output |
* | --- |
* | "last seen: yesterday" |
*
* @param {Lastseenyesterday2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const lastseenyesterday2 = /** @type {((inputs?: Lastseenyesterday2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lastseenyesterday2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("last seen: yesterday")
	if (locale === "es") return /** @type {LocalizedString} */ ("últ. vez: ayer")
	return /** @type {LocalizedString} */ ("в сети: вчера")
});
export { lastseenyesterday2 as "lastSeenYesterday" }